import { Hint } from "react-ui";
// @ts-ignore
import React from "react";

const hintWrapper = (fullText: string, croppedText: string): JSX.Element => (
    <Hint text={fullText} pos="right top">
        {croppedText}
    </Hint>
);

export const cropFileName = (fileName: string) => {
    if (fileName.length > 60) {
        return hintWrapper(fileName, `${fileName.slice(0, 50)}...${fileName.slice(-10)}`);
    }
    return <>{fileName}</>;
};
